<template>
    <div>

        <v-data-table :loading="isLoading"
                      :headers="headers"
                      :items="allList" sort-by="calories" class="elevation-1" hide-default-footer>
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>Cd Link</v-toolbar-title>
                    <v-divider class="mx-4" inset vertica></v-divider>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dark
                           class="mb-2"
                           v-on:click="newItem()">New CdLink
                    </v-btn>
                    <v-dialog v-model="addEditDialog" max-width="80%">
                        <v-card>
                            <v-card-title>
                                <span class="headline">{{ formTitle }}</span>
                            </v-card-title>

                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-text-field :rules="[rules.required]" v-model="editedItem.name"
                                                          label="Name"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-text-field :rules="[rules.required]" v-model="editedItem.link"
                                                          label="Link"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-autocomplete
                                                    v-model="editedItem.category"
                                                    :items="cdLinkCategories"
                                                    :loading="cdLinkCategoryLoading"
                                                    :search-input.sync="searchCdLinkCategory"
                                                    chips
                                                    clearable
                                                    hide-details
                                                    hide-selected
                                                    item-text="name"
                                                    label="Search For CdLink Category"
                                                    return-object
                                                    solo
                                            >
                                                <template v-slot:selection="{ attr, on, item, selected }">
                                                    <v-chip
                                                            v-bind="attr"
                                                            :input-value="selected"
                                                            color="blue-grey"
                                                            class="white--text"
                                                            v-on="on">
                                                        <span v-text="item.name"></span>
                                                    </v-chip>
                                                </template>
                                            </v-autocomplete>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                                <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>

                <v-text-field
                        v-on:keyup.enter="searchAll"
                        v-model="search"
                        label="Search"
                        single-line
                        hide-details
                        class="pb-3 px-3"
                ></v-text-field>
            </template>


            <template v-slot:item.actions="{ item }">
                <v-icon
                        small
                        class="mr-2"
                        @click="editItem(item)"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                        small
                        @click="deleteItem(item)"
                >
                    mdi-delete
                </v-icon>
            </template>
            <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">Reset</v-btn>
            </template>
        </v-data-table>
        <pagination :page="page" :total-page="totalPage" @paginate="paginate($event)"></pagination>
    </div>
</template>

<script>
    import {mapGetters, mapActions, mapMutations} from 'vuex'
    import Pagination from '../../components/Pagination'
    import {CdLinkCategoryService} from "../../services";

    export default {
        name: "CdLinkPanel",
        components: {
            Pagination
        },
        data: () => ({
            loading: false,
            cdLinkCategoryLoading: false,
            search: '',
            searchCdLinkCategory: '',
            rules: {
                required: value => !!value || 'Required.'
            },
            headers: [
                {
                    text: 'Name',
                    align: 'start',
                    sortable: true,
                    value: 'name',
                },
                {text: 'Actions', value: 'actions', sortable: false},
            ],
            editedIndex: -1,
            editedItem: {
                parseItem: null,
                name: ''
            },
            defaultItem: {
                parseItem: null,
                name: '',
            },
            selectedCdCategoryModel: null,
            cdLinkCategories: []
        }),
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? 'New CdLink' : 'Edit CdLink'
            },
            page() {
                return this.getPagination().page;
            },
            perPage() {
                return this.getPagination().perPage;
            },
            totalPage() {
                return this.getPagination().totalPage;
            },
            allList() {
                return this.getAll();
            },
            isLoading() {
                return this.getLoading()
            },
            addEditDialog: {
                get() {
                    return this.showAddEditDialog();
                },
                set(value) {
                    this.setShowAddEditDialog(value);
                }
            }
        },
        watch: {
            dialog(val) {
                val || this.close()
            },
            searchCdLinkCategory(newVal) {
                if (this.cdLinkCategories.length > 0 || this.cdLinkCategoryLoading) return;

                this.cdLinkCategoryLoading = true;

                // Lazily load input items
                CdLinkCategoryService.getAll(null, newVal)
                    .then(res => {
                        console.log(res);
                        this.cdLinkCategories.push(...res.results);
                    })
                    .catch(err => {
                        console.log(err)
                    })
                    .finally(() => (this.cdLinkCategoryLoading = false))
            }
        },
        created() {
            this.initialize()
        },
        methods: {
            ...mapMutations({
                setShowAddEditDialog: 'cdLink/SHOW_ADD_EDIT_DIALOG'
            }),
            ...mapGetters({
                getPagination: 'cdLink/getPagination',
                getLoading: 'cdLink/getLoading',
                getAll: 'cdLink/getAll',
                showAddEditDialog: 'cdLink/showAddEditDialog'
            }),
            ...mapActions({
                requestAll: 'cdLink/requestAll',
                setPage: 'cdLink/setPage',
                setSearch: 'cdLink/setSearch',
                setSave: 'cdLink/setSave',
                setEdit: 'cdLink/setEdit'
            }),
            initialize() {
                this.requestAll();
            },
            newItem() {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
                this.setShowAddEditDialog(true);
            },
            editItem(item) {
                this.editedIndex = this.allList.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.setShowAddEditDialog(true)
            },
            close() {
                this.setShowAddEditDialog(false);
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1
            },
            save() {
                if (this.editedIndex > -1) {
                    if (this.editedItem.name.length === 0) {
                        return;
                    }
                    this.setEdit({itemToEdit: this.editedItem, itemIndex: this.editedIndex});
                } else {
                    if (this.editedItem.name.length === 0) {
                        return;
                    }
                    this.setSave(this.editedItem);
                }
            },
            paginate(page) {
                this.setPage(page);
            },
            searchAll() {
                this.setSearch(this.search);
            }
        },

    }
</script>

<style scoped>

</style>